export default __webpack_public_path__ + "static/media/team_default.913007fd.png";